import React, { useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import DarkPopUp from "./steps/pages/DarkPopUp/DarkPopUp";
import {
  setCurrentPage,
  setShowInnerPopup,
  setInnerPopupType,
  setPopupCloseBtnClicked,
  resetPopupInfo,
  resetState,
} from "./BusinessClientEsimUpgradeSlice";
import {
  getPageByStatus,
  getInnerPopupByType,
} from "./steps/pages/pagesConfigs";

const BusinessClientEsimUpgradeMain = ({
  contentData,
  context,
  currentPage,
  innerPopupType,
  showInnerPopup,
  sliceData,
  setCurrentPage,
  setShowInnerPopup,
  setInnerPopupType,
  setPopupCloseBtnClicked,
  resetPopupInfo,
  resetState,
  contactOrgId,
}) => {
  const [simSerialNumberLocal, setSimSerialNumberLocal] = useState(null);

  useEffect(() => {
    const serialFromRedux =
      sliceData?.esimPriceApiResponse?.simSerialNumber;

    if (serialFromRedux && !simSerialNumberLocal) {
      setSimSerialNumberLocal(serialFromRedux);
    }
  }, [sliceData, simSerialNumberLocal]);

  useEffect(() => {
    return () => resetState();
  }, []);

  const renderPageByStatus = useMemo(() => {
    return getPageByStatus({
      sliceData,
      contentData,
      contactOrgId,
      simSerialNumber: simSerialNumberLocal,
    });
  }, [currentPage, sliceData, contentData, contactOrgId, simSerialNumberLocal]);

  const renderInnerPopupByType = useMemo(
    () =>
      showInnerPopup
        ? getInnerPopupByType({ sliceData, contentData })
        : null,
    [showInnerPopup, innerPopupType, sliceData, contentData]
  );

  return (
    <div className='business-client-esim-upgrade-main'>
      {renderPageByStatus}
      {showInnerPopup && (
        <DarkPopUp
          popUpProps={{showPopUp: showInnerPopup, onClose: () => setPopupCloseBtnClicked(true)}}
          cleanupFunc={() => resetPopupInfo()}>
          {renderInnerPopupByType}
        </DarkPopUp>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    currentPage: state.BusinessClientEsimUpgradeSlice?.currentPage,
    showInnerPopup: state.BusinessClientEsimUpgradeSlice?.showInnerPopup,
    innerPopupType: state.BusinessClientEsimUpgradeSlice?.innerPopupType,
    sliceData: state.BusinessClientEsimUpgradeSlice,
    contactOrgId: state.portalsBlock?.selectedHetPayId,
  };
};

const mapDispatchToProps = {
  setCurrentPage,
  setShowInnerPopup,
  setInnerPopupType,
  setPopupCloseBtnClicked,
  resetPopupInfo,
  resetState,
};

export default connect(mapStateToProps, mapDispatchToProps)(BusinessClientEsimUpgradeMain);
